import React, { ReactNode } from 'react';

import { classnames, padding } from '@lumapps/classnames';
import { FlexBox, FlexBoxProps } from '@lumapps/lumx/react';

const CLASSNAME = 'reactions-block';

export interface ReactionsBlockProps extends FlexBoxProps {
    className?: string;
    children: ReactNode;
}

/** Block to but ReactionButton and CommentButton inside */
export const ReactionsBlock: React.FC<ReactionsBlockProps> = ({
    children,
    className = padding('all', 'tiny'),
    ...flexProps
}) => (
    <FlexBox className={classnames(CLASSNAME, className)} orientation="horizontal" {...flexProps}>
        {children}
    </FlexBox>
);
